

const carArrays = [
  {
    id: 10,
    brand: "Volkswagen",
    model: "Volkswagen Golf",
    genre: "hatchback",
    price: "$58/day",
    year: 2019,
    transmission: "MT",
    image: require("../media_folder/CarModel/volks.png"),
  },
  {
    id: 6,
    brand: "Mercedes-Benz",
    model: "Mercedes-Benz C-Class",
    genre: "sedan",
    price: "$90/day",
    year: 2021,
    transmission: "AT",
    image: require("../media_folder/CarModel/benz.png"),
  },
  {
    id: 7,
    brand: "Audi",
    model: "Audi A4",
    genre: "sedan",
    price: "$78/day",
    year: 2020,
    transmission: "AT",
    image: require("../media_folder/CarModel/audi.png"),
  },
  {
    id: 8,
    brand: "Tesla",
    model: "Tesla Model S",
    genre: "sedan",
    price: "$110/day",
    year: 2023,
    transmission: "AT",
    image: require("../media_folder/CarModel/tesla.png"),
  },
  {
    id: 9,
    brand: "Nissan",
    model: "Nissan Altima",
    genre: "sedan",
    price: "$63/day",
    year: 2017,
    transmission: "CVT",
    image: require("../media_folder/CarModel/nissan.png"),
  },
  {
    id: 2,
    brand: "Honda",
    model: "Honda Accord",
    genre: "sedan",
    price: "$67/day",
    year: 2021,
    transmission: "AT",
    image: require("../media_folder/CarModel/honda accord.png"),
  },
  {
    id: 3,
    brand: "Ford",
    model: "Ford Mustang",
    genre: "coupe",
    price: "$72/day",
    year: 2020,
    transmission: "MT",
    image: require("../media_folder/CarModel/ford mustang.png"),
  },
  {
    id: 4,
    brand: "Chevrolet",
    model: "Chevrolet Silverado",
    genre: "truck",
    price: "$80/day",
    year: 2018,
    transmission: "AT",
    image: require("../media_folder/CarModel/Chevy Silverado.png"),
  },
  {
    id: 5,
    brand: "BMW",
    model: "BMW 3 Series",
    genre: "sedan",
    price: "$85/day",
    year: 2022,
    transmission: "AT",
    image: require("../media_folder/CarModel/bmw.png"),
  },

  {
    id: 11,
    brand: "Subaru",
    model: "Subaru Crosstrek",
    genre: "SUV",
    price: "$75/day",
    year: 2021,
    transmission: "CVT",
    image: require("../media_folder/CarModel/subaru.png"),
  },
  {
    id: 12,
    brand: "KIA",
    model: "KIA Seltos",
    genre: "SUV",
    price: "$70/day",
    year: 2022,
    transmission: "AT",
    image: require("../media_folder/CarModel/kia.png"),
  },
  {
    id: 1,
    brand: "Toyota",
    model: "Toyota Camry",
    genre: "sedan",
    price: "$65/day",
    year: 2019,
    transmission: "AT",
    image: require("../media_folder/CarModel/toyota camry.png"),
  },
];

export default carArrays;
